export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Pedido caducado",
      "649f8aefc1c0": "Reciclaje fallido",
      "649f8aefc9c0": "Obtener una nueva valoración",
      "TradeIn": "Proceso de Trade-In",
      "logistic": "Descargar etiqueta de envío",
      "start": "Comenzar",
      "success": "Has firmado correctamente la recepción del nuevo dispositivo",
      "qc": "Control de calidad del dispositivo antiguo",
      "business": "Completaremos la inspección de tu dispositivo antiguo en un plazo de 3 días laborables",
      "completed": "Completado",
      "successfully": "¡Felicidades! Tu Trade-In se ha completado correctamente",
      "orderInfor": "Información del pedido",
      "orderID": "ID del pedido de Trade-In",
      "orderNum": "ID del pedido del nuevo dispositivo",
      "createTime": "Fecha de creación",
      "brand": "Marca estimada",
      "model": "Modelo estimado",
      "price": "Valor del dispositivo antiguo",
      "bonus": "Bonificación",
      "reclaimFailure": "Debido a que no enviaste el dispositivo en un plazo de 10 días desde su recepción, el pedido de reciclaje ha caducado y ha sido cancelado. Si aún deseas completar el reciclaje del dispositivo, haz clic en el botón de abajo para comprobar la última valoración.",
      "total": "Precio total",
      "logisticInfo": "Información logística",
      "available": "No hay información logística disponible",
      "logisticNum": "Número de seguimiento",
      "failRey": "Lamentamos que tu participación en el programa de reciclaje de OnePlus no se haya completado correctamente. Si tienes previsto reciclar otros productos electrónicos, puedes hacer clic en el botón de abajo para obtener una valoración rápida.",
      "userRes": "El usuario ya ha rechazado la oferta.",
      "successPrice": "El siguiente precio corresponde a la valoración profesional. Si estás de acuerdo, puedes continuar con el proceso de Trade-In. Si la rechazas, el dispositivo te será devuelto en unos pocos días laborables.",
      "sure": "Aceptar",
      "Reject": "Rechazar",
      "congratulation": "¡Felicidades! La inspección no mostró diferencias.",
      "finPirce": "Precio final",
      "copySuccess": "Copia exitosa",
      "copyfail": "Error al copiar",
      "sureSuccess": "Confirmar transacción exitosa",
      "submitError": "Envío fallido",
      "detectionResult": "Resultado de la inspección",
      "Collected": "Realizar pedido",
      "inTransit": "En tránsito",
      "656g0lj3sav6": "Proceso de reciclaje",
      "656g0lj3cd5a": "Rellena correctamente tu información personal y completa el pedido",
      "656g0lj3dr9a": "La inspección de tu teléfono móvil se completará en un plazo de 48 horas desde su llegada a nuestro centro",
      "656g0lj3epal": "Una vez completada la inspección, te contactaremos por correo electrónico con la oferta final",
      "656g0lj3pda2": "Tu valoración",
      "656g0lj3ed3d": "Control de calidad profesional",
      "656g0lj3esf3": "Copiar",
      "expertDiscount": "Código promocional",
      "invalidCode": "Código no válido",
      "toastTip": "Marca la casilla para aceptar la Política de privacidad y los Términos",
      "649f8aef26sf": "Proceso de Trade-In",
      "checkTitle": "Información de prueba",
      "basicInformation": "Información básica",
      "understand": "Entendido"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Rechazar reciclaje",
      "64a9shqq3k00": "Confirmas que rechazas el reciclaje",
      "64a9shqq3r00": "Cancelación exitosa",
      "64a9shqq3ws0": "Error al cancelar",
      "sureCancel": "Confirmar cancelación"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "¿Quiénes",
      "646u995lv9g0": "somos?",
      "646u9d5lv9g0": "Danghuan es una empresa especializada en el reciclaje, tratamiento y venta de productos digitales 3C, como teléfonos móviles, tabletas, portátiles y relojes inteligentes. Nuestra compañía se dedica a mejorar la eficiencia del reciclaje electrónico y promover un mercado de segunda mano saludable. Actualmente mantenemos alianzas estratégicas oficiales con OPPO, Vivo, OnePlus, Realme y otros. Nuestra expansión internacional abarca India, Tailandia, Vietnam, Camboya y ahora Europa.",
      "646u995dv9g0": "Nuestra presencia global nos posiciona como socio estratégico de operadores, fabricantes y mayoristas con alcance continental y transcontinental.",
      "646u99slv9g0": "Colaboramos con los principales fabricantes y contamos con un amplio inventario de dispositivos de gama baja, media y alta, lo que nos permite ofrecer soluciones personalizadas y precios competitivos."
    },
    "business": {
      "646v04syvpk0": "¿Te interesa adquirir nuestros productos?",
      "646v04syxs80": "En Danghuan ofrecemos una amplia gama de teléfonos, tabletas y relojes inteligentes, disponibles en distintos niveles de clasificación para satisfacer diversas necesidades comerciales.",
      "646v04syy6g0": "Contacte con nuestro Responsable de Ventas y Compras:",
      "646v04syya80": "Quiero comprar",
      "646v04syydg0": "Introduzca su nombre",
      "646v04syyh40": "Introduzca su número de teléfono",
      "646v04syyyw0": "Introduzca su correo electrónico",
      "646v0gsyz1s0": "País:",
      "646v04syz1s0": "Por favor, elija una opción",
      "646v04syz4o0": "He leído y acepto la",
      "646v04syzkc0": "Política de privacidad",
      "646v04syzok0": "Contáctenos",
      "646v04syzvo0": "Por favor, introduzca su número de teléfono",
      "646v04syzys0": "Por favor, introduzca su correo electrónico",
      "646v04sz01o0": "Por favor, introduzca un correo electrónico válido",
      "646v04sz04g0": "Por favor, introduzca su nombre",
      "646v04sz0740": "Por favor, marque la casilla para aceptar la política de privacidad",
      "646v04sz0a00": "Envío realizado con éxito",
      "646v04sz0cw0": "Error en el envío",
      "title1": "Clasificación Transparente de Dispositivos",
      "text1-1": "Para apoyar sus decisiones de compra, le recomendamos revisar nuestro documento detallado de Clasificación. Este describe los estándares estéticos y funcionales de cada categoría, lo que le permitirá tomar decisiones informadas y acordes a sus expectativas.",
      "title2": "Apoyo al cliente excepcional",
      "text2-1": "Reconocemos las necesidades únicas de cada cliente, por eso nuestro equipo de profesionales de ventas multilingües está comprometido a ofrecer una asistencia personalizada y experta.",
      "title3": "Compromiso con la tecnología sostenible",
      "text3-1": "Estamos comprometidos a ampliar el acceso global a soluciones tecnológicas sostenibles, asegurando que nuestros procesos generen valor para todas las partes involucradas.",
      "text3-2": "Para más información o para solicitar un pedido de prueba, ponte en contacto con nosotros. Nuestro equipo está listo para ayudarte con profesionalismo y dedicación."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Recibe tu pago rápidamente en solo 4 pasos",
      "s1": "Primer paso",
      "s1t": "Empaqueta tu dispositivo para que llegue en las mismas condiciones en que lo enviaste.",
      "s2": "Segundo paso",
      "s2t": "Entrega tu paquete en nuestro punto de recogida.",
      "s3": "Tercer paso",
      "s3t": "Verificaremos tu dispositivo y te daremos una valoración.",
      "s4": "Cuarto paso",
      "s4t": "Recibe tu pago rápidamente."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Mantente informado",
      "section3-text2": "Tabletas",
      "section3-text4": "Relojes",
      "section3-text5": "Otros",
      "title": "Valoración rápida",
      "t1": "Selecciona el tipo y comienza la valoración para obtener una oferta justa.",
      "t2": "¡Pasos sencillos para disfrutar de nuestro servicio de reciclaje rápido!"
    },
    "section6": {
      "646txzpazuc0": "Sobre Danghuan",
      "666txzpazuc0": "Una empresa especializada en el reciclaje y la reutilización de teléfonos, tabletas y otros dispositivos digitales, dedicada a ofrecer un servicio simple, seguro y eficiente, permitiendo a cada cliente reciclar fácilmente su dispositivo usado.",
      "646txzpb0rk0": "Detalles",
      "646txzpb0xc0": "Reciclamos 12 marcas"
    },
    "section7": {
      "646ns2k5f7k0": "Nuestro servicio está siempre disponible",
      "646ns2k5gmw0": "Atención al cliente: de lunes a viernes de 9:00 a 18:00 CET (UTC+1:00) Madrid, España",
      "646ns2k5gs40": "Introduzca su nombre",
      "646ns2k5gx40": "Introduzca su número de teléfono",
      "646ns2k5img0": "Introduzca su correo electrónico",
      "646ns2k5isw0": "Escribe un mensaje antes de que nos pongamos en contacto contigo",
      "646ns2k5iws0": "Contáctenos",
      "646ns2k5j140": "Por favor, introduzca su número de teléfono",
      "646ns2k5j4g0": "Por favor, introduzca su correo electrónico",
      "646ds2k5j4g0": "Correo electrónico",
      "646ns2k5j6c0": "Por favor, introduzca un correo electrónico válido",
      "646ns2k5j8g0": "Contáctenos",
      "646ns2k5jak0": "C.I.F:",
      "646ns2k5jck0": "Dirección",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, España",
      "646ns2k5jgc0": "Por favor, introduzca su nombre",
      "646ns2k5ji40": "Por favor, marque la casilla para aceptar la política de privacidad",
      "646ns2k5jk00": "Envío realizado con éxito",
      "646ns2k5jm80": "Error en el envío",
      "646ny1rgz3c0": "He leído y acepto la ",
      "646ny1rh2k40": "Política de privacidad"
    },
    "successMain": {
      "647qmd42l1s0": "¡Pedido recibido con éxito!",
      "647qmd42mss0": "Por favor, presta atención al correo con las instrucciones de envío enviado desde no-reply@danghuan.eu. Si no lo has recibido, revisa tu carpeta de SPAM o contacta con nuestro servicio al cliente en insta360@danghuan.eu.",
      "647qmd42mz80": "Nuestra oferta",
      "647qmd42yeo0": "Consejos antes del envío",
      "orderTime": "Fecha del pedido",
      "text1": "Envío gratuito",
      "text2": "Por favor, presta atención al documento de envío enviado a tu correo electrónico.",
      "text3": "Copia de seguridad de datos",
      "text4": "Para proteger tus datos, realiza una copia de seguridad y elimina o restaura el dispositivo a los valores de fábrica.",
      "text5": "Carga",
      "text6": "Carga tu teléfono al menos al 1 % antes de enviarlo para agilizar la inspección.",
      "downloadDec": "Por favor, descargue la Declaración de Integridad."
    },
    "tradeInProcess": {
      "649f8aefats0": "Pedido caducado",
      "649f8aefc1c0": "Reciclaje fallido",
      "649f8aefc9c0": "Obtener una nueva valoración",
      "TradeIn": "Proceso de Trade-In",
      "logistic": "Descargar etiqueta de envío",
      "start": "Comenzar",
      "success": "Has firmado correctamente la recepción del nuevo dispositivo",
      "qc": "Control de calidad del dispositivo antiguo",
      "business": "Completaremos la inspección de tu dispositivo antiguo en un plazo de 3 días laborables",
      "completed": "Completado",
      "successfully": "¡Felicidades! Tu Trade-In se ha completado correctamente",
      "orderInfor": "Información del pedido",
      "orderID": "Número de pedido de reciclaje",
      "orderNum": "ID del pedido del nuevo dispositivo",
      "createTime": "Fecha de creación",
      "brand": "Marca estimada",
      "model": "modelo",
      "price": "Valor del dispositivo antiguo",
      "bonus": "Bonificación",
      "total": "Precio total",
      "logisticInfo": "Información logística",
      "available": "No hay información logística disponible",
      "logisticNum": "Número de seguimiento",
      "failRey": "Lamentamos que tu participación en el programa de reciclaje de OnePlus no se haya completado correctamente. Si tienes previsto reciclar otros productos electrónicos, puedes hacer clic en el botón de abajo para obtener una valoración rápida.",
      "userRes": "El usuario ya ha rechazado la oferta.",
      "successPrice": "El siguiente precio corresponde a la valoración profesional. Si estás de acuerdo, puedes continuar con el proceso de Trade-In. Si la rechazas, el dispositivo te será devuelto en unos pocos días laborables.",
      "sure": "Aceptar",
      "Reject": "Rechazar",
      "congratulation": "¡Felicidades! La inspección no mostró diferencias.",
      "finPirce": "Precio final",
      "copySuccess": "Copia exitosa",
      "copyfail": "Error al copiar",
      "sureSuccess": "Confirmar transacción exitosa",
      "submitError": "Envío fallido",
      "detectionResult": "Resultado de la inspección",
      "Collected": "Recogido",
      "inTransit": "En tránsito / Envío",
      "understand": "Entendido",
      '656g0lj3sf6e': 'Los bonos promocionales son ofrecidos y gestionados por las marcas asociadas. Se abonarán por separado y no forman parte de la valoración del dispositivo antiguo.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Rechazar reciclaje",
      "64a9shqq3k00": "Confirmas que rechazas el reciclaje",
      "64a9shqq3r00": "Cancelación exitosa",
      "64a9shqq3ws0": "Error al cancelar",
      "sureCancel": "Confirmar cancelación"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Información personal",
      "649fhwp9zbo0": "Sube una foto clara de tu paquete",
      "649fhwpa1900": "Descargar la etiqueta de envío",
      "649fhwpa1l00": "Descargar la etiqueta de envío",
      "649fhwpa1tc0": "Entrega completada",
      "649fhwpa2100": "Foto del paquete y Declaración de honestidad",
      "649fhwpa2880": "Ejemplo de cómo colocar la etiqueta de envío",
      "649fhwpa2h80": "Nota",
      "649fhwpa2qk0": "Empaqueta el teléfono con plástico de burbujas y rellena la caja con papel para evitar daños durante el transporte.",
      "649fhwpa2xs0": "Rellena los espacios vacíos con material protector.",
      "649fhwpa3fk0": "Etiqueta logística: lleva la etiqueta (digital o impresa) al punto de entrega; la etiqueta oficial se imprimirá allí.",
      "649fhwpa3v40": "Envía tu teléfono usado lo antes posible. Si no lo envías en 10 días, el pedido será cancelado.",
      "649fhwpa42s0": "Consulta de puntos de entrega",
      "649fhwpa4as0": "Descargar etiqueta",
      "649fhwpa4jo0": "Subir",
      "649fhwpa4ok0": "Inicio",
      "649fhwpa4to0": "Envío completado correctamente",
      "649fhwpa4yk0": "¡Felicidades, descarga exitosa!",
      "649fhwpasf3s": "Atención",
      "649fhwpaa6f3": "Imprime y firma la Declaración de honestidad, luego haz una foto junto al paquete del dispositivo y súbela."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Redes sociales",
      "646d71qugz40": "Pago fácil",
      "646u51qugz40": "Logística",
      "646u5dqui780": "Política de privacidad",
      "646uddqui780": "Términos y condiciones",
      "646u51qui780": "Preguntas frecuentes (FAQ)"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Sobre Danghuan",
      "646ntjwmn580": "Negocio",
      "646nt7hwils0": "Contáctanos",
      "646nt7hwipg0": "Comprar",
      "646nt7hwis00": "Vender"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Estimación gratuita"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Introduce el modelo que deseas vender",
      "646wgb1nj8o0": "Término de búsqueda",
      "646wgb1nji80": "Activé la búsqueda deslizante",
      "empty": "Lo sentimos, el modelo no existe",
      "confirm": "Confirmar",
      "cancle": "Cancelar",
      "dialogText": "¿Seguro que deseas eliminar todo el historial \nde registros?"
    }
  },
  "PCProduct": {
    "empty": "Lo sentimos, el modelo no existe"
  },
  "PCBrandTab": {
    "index": "Marca"
  },
  "PCCategoryTab": {
    "index": "Categoría"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Pedir en línea",
      "646xagqwkuw0": "Envío gratuito",
      "646xagqwmao0": "Prueba",
      "646xagqwmlc0": "Pago rápido"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Inicio"
    }
  },
  "router": {
    "selectModel": "Modelos",
    "selectProperty": "Problemas del dispositivo",
    "price": "Precio estimado",
    "priceOrder": "Realizar pedido",
    "orderSuccess": "Pedido completado correctamente"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Seleccionar modelo de nuevo",
      "646ymq6ot0k0": "Recordatorio",
      "646ymq6pd100": "Antes del envío, asegúrate de cerrar sesión en la cuenta en la nube",
      "646ymq6pekw0": "/bloqueo de pantalla / Apple ID en el dispositivo antiguo."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Seleccionar el estado del dispositivo",
      "647h1f4yr6c0": "Precio estimado",
      "647h1f4yso80": "Bonificación estimada",
      "text1": "Envío gratuito",
      "text2": "Ofrecemos un servicio de envío y logística gratuito",
      "text3": "Pago inmediato",
      "text4": "Realizaremos el pago en un plazo de 3 días laborables tras recibir tu dispositivo usado.",
      "64tve23zt0g0": "Envío y paquete de venta gratuitos",
      "64tve23zup00": "Eliminación segura de datos",
      "64tve23zuy40": "¿No estás satisfecho? Devoluciones gratuitas",
      "64tve23zv7g0": "El pago se procesará en 3 días laborables tras recibir el dispositivo",
      "64tve23zvbg0": "Elige tu método de entrega",
      "64tve23zvf80": "Tienes 10 días para enviar tu teléfono.",
      "64tve23zvjc0": "Obtén una etiqueta de envío gratuita y envía tu dispositivo",
      "64tve23zvms0": "Recibe la etiqueta de envío por correo electrónico",
      "64tve23zvqg0": "Nota:",
      "64tve23zvyo0": "Debido a restricciones relacionadas con las baterías de litio, no envíes el teléfono si sospechas que la batería puede estar dañada o defectuosa.",
      "64tve23zwak0": "No podemos devolver accesorios ni embalajes enviados con el dispositivo.",
      "64tve23zwgs0": "Siguientes pasos para vender tu teléfono",
      "64tve23zwm80": "Rellena tus datos de contacto",
      "64tve23zwt00": "Prepara tu teléfono para el envío",
      "64tve23zwwk0": "Tu dispositivo será revisado al llegar. Si la información proporcionada no es correcta, te enviaremos una nueva oferta. Puedes aceptar la nueva oferta o recibir tu teléfono de vuelta de forma gratuita."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "Canal de compra",
      "646ynp3ueas0": "Necesita activación, no puede realizar llamadas normalmente",
      "646ynp3uehw0": "Introduce el número IMEI",
      "646ynp3uem40": "Marca *#06# en el teclado para ver el IMEI del teléfono"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Ver la oferta"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Recordatorio: el precio de los dispositivos electrónicos puede disminuir hasta un 6 %, por lo que recomendamos enviar tu paquete lo antes posible.",
      "647hqss760c0": "He leído y acepto la",
      "647hqss764w0": "Política de privacidad",
      "647hqss76ac0": "Términos y condiciones",
      "647hqss76dg0": "Enviar",
      "647hqss76gw0": "Precio total (Valoración del dispositivo usado)",
      "text1": "Total",
      "text2": "Precio estimado",
      "text3": "Bono estimado",
      "dialogTitle": "Aviso",
      "dialogText": "Haga clic en el botón CONFIRMAR y revise su correo electrónico para continuar con el siguiente paso",
      "dialogBtn": "CONFIRMAR"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Información del pedido",
      "647kboa06ys0": "Nombre",
      "647kboa0d6v8": "Código del país",
      "647kboa078s0": "Teléfono",
      "647kboa07d00": "Dirección",
      "647kboa07jk0": "País",
      "647kboa07p80": "Por favor, seleccione",
      "647kboa08b40": "Código postal",
      "647kboa08h00": "Ciudad",
      "647kboa08zc0": "Dirección",
      "647kboa09440": "Información bancaria",
      "647kboa096w0": "Verificación de correo electrónico",
      "647kboa09ao0": "Correo electrónico",
      "647kboa09dk0": "Código de verificación",
      "647kboa09u40": "Introducir",
      "647kboa09z80": "Enviar",
      "647kboa0ak00": "Error en el formato del correo electrónico",
      "647kboa0aog0": "Envío exitoso",
      "send": "Enviado",
      "submit": "Enviar",
      "error": "Error en el código de verificación",
      "64jjt96fg400": "Por favor, introduzca el código de verificación",
      "64jjt96fki00": "Por favor, obtenga el código de verificación",
      "idNumber": "Número de tarjeta de identidad / Número de ID",
      "declaration": "Declaración de integridad",
      "download": "Descargar",
      "647kboa0idc0": "Identificación personal (ID)",
      "647kboa0idc1": "(el número de identidad oficial emitido por su país, utilizado para la identificación en procedimientos legales, fiscales o administrativos. Puede ser su DNI, NIE, número de identificación fiscal, número de identificación personal, CNP, u otro documento nacional equivalente, dependiendo de su país de residencia.)",
      "647kboa0idc2": "(el número de identidad oficial emitido por su país, utilizado para la identificación en procedimientos legales, fiscales o administrativos. Puede ser su DNI, NIE, número de identificación fiscal, número de identificación personal, CNP, u otro documento nacional equivalente, dependiendo de su país de residencia.)",
      "idError": "Número de ID no válido",
      "ibanTip": "Utilizado para recibir el pago del dispositivo antiguo.",
      "addreddPlaceholder": "Este campo admite hasta 105 caracteres"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Página principal",
      "notRecyclable": "Este tipo de dispositivo no se puede reciclar",
      "IKnow": "Entendido",
      "tips": "Consejos"
    }
  },

  "blog": {
    "blogList": {
        "64wgr171lsk0": "Vistas",
        "64wgr171nq40": "No hay contenido relacionado disponible",
        "64wgr171av65": "Fecha"
    },
    "blogDetail": {
        "64wgr9y5r7s0": "Vistas",
        "64wgr171wdx9": "Detalles"
    }
  },

  "cookieNotice": {
    "title": "Aviso de cookies",
    "description": "Utilizamos cookies para mejorar su experiencia de navegación. Al continuar usando este sitio web, usted acepta nuestra",
    "cookiePolicy": "Política de cookies",
    "acceptAll": "Aceptar todas las cookies",
    "acceptNecessary": "Aceptar solo las cookies necesarias",
    "customize": {
      "title": "Seleccione los tipos de cookies que desea aceptar:",
      "necessary": {
        "label": "Cookies necesarias",
        "description": "Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden desactivar."
      },
      "analytics": {
        "label": "Cookies analíticas",
        "description": "Estas cookies nos ayudan a comprender cómo los visitantes interactúan con nuestro sitio web."
      },
      "marketing": {
        "label": "Cookies de marketing",
        "description": "Estas cookies rastrean la actividad del usuario en varios sitios web para ofrecer anuncios relevantes."
      }
    },
    "save": "Guardar configuración",
    "cancel": "Cancelar"
  }
}